import service from '../../../../../services';

export default {
  /**
   * Busca todas as regionais de acordo com a empresa
   * @return {<Promise<array>>}
   */
  async getRegionais() {
    try {
      const result = await service.getAll(
        'Regional',
        {},
        'list/idEmpresa=' + this.idEmpresa,
      );
      return Promise.resolve(result.data);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  /**
   * Busca todos os usuários consultores de uma regional
   * @param {object} obj com o idEmpresa e idRegional
   * @return {<Promise<array>>}
   */
  async getConsultores(obj) {
    try {
      const result = await service.post(
        'Usuario',
        'busca-consultores-por-regional',
        obj,
      );
      return Promise.resolve(result.data);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  /**
   * Busca registro de importações de um usuário
   * @param {number} idUsuarioUpload
   * @return {Promise<object>}
   */
  async getImportacoes(idUsuarioUpload) {
    try {
      const result = await service.post('Leads', 'buscar-importacoes', {
        idUsuarioUpload,
      });
      return Promise.resolve(result.data);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  /**
   * Realiza upload do arquivo no S3
   * @param {FormData} file {file: file}
   * @param {number} idUsuarioUpload id do usuário que está fazendo o upload
   * @return {Promise<object>} com a propriedade UrlImage, que é a url do arquivo no S3
   */
  async uploadArquivo(file, idUsuarioUpload) {
    try {
      const result = await service.upload(
        'upload-v2',
        `Leads/${idUsuarioUpload}`,
        file,
      );
      return Promise.resolve(result);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  /**
   * Realiza registro do formulário e das leads do arquivo no banco de dados
   * @param {FormData} obj {form: <obj>, file: <formData>}
   * @return {Promise<object>}
   */
  async registrarArquivo(obj) {
    try {
      const result = await service.post('Leads', 'registrar-arquivo', obj);
      return Promise.resolve(result.data);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  /**
   * Busca registro de leads de uma importação
   * @param {object} idImportacao
   * @return {Promise<object>}
   */
  async getLeads(idImportacao) {
    try {
      const result = await service.post('Leads', 'buscar-leads', idImportacao);
      return Promise.resolve(result.data);
    } catch (error) {
      return Promise.reject(error);
    }
  },
};
